export default {
  brandGold: '#CFB162',
  darkBrandGold: '#b7994a',
  navyBlue: '#4381B9',
  black: '#000000',
  stone00: '#121927',
  stone01: '#171E2D',
  stone02: '#1E2534',
  stone03: '#2D3446',
  stone04: '#526079',
  stone05: '#B3C6D8',
  stone06: '#1A2130',
  stone07: '#EAF1F8',
  grey00: '#515358',
  grey01: '#A4A4A4',
  grey02: '#D8D8D8',
  grey03: '#E7E7E7',
  grey04: '#F9F9F9',
  grey05: '#EEF4F9',
  grey06: '#F7F7F7',
  white: '#FFFFFF',
  green: '#9AC646',
  greenNext: '#9bc655',
  orange: '#FF6336',
  red: '#f83902',
  yellow: '#FFBE3D',
  blue: '#50BAF3',
  deepBlue: '#002b7d',
  turquoise: '#00d8b7',
  flamingo: '#E42E9A',
  sky: '#B8DCF8',

  prism01: '#9FBD6A',
  prism02: '#0092C7',
  prism03: '#E9B03E',
  prism04: '#E35F3D',
  prism05: '#4E8B08',
  prism06: '#78BEE3',
  prism07: '#BE873D',
  prism08: '#C9494A',
  prism09: '#55AC7A',
  prism10: '#16D2D3',
  prism11: '#3EC3CB',
  prism12: '#00A69D',
  prism13: '#BD75AE',
  prism14: '#C3055F',
  prism15: '#CCB0FF',
  prism16: '#FFB5CD',
  prism17: '#FFA800',
  prism18: '#E44900',
  prism19: '#BC162C',
  prism20: '#FF7075',
  prism21: '#F22013',
  prism22: '#FF6E00',

  slice1: '#50a8c0',
  slice2: '#8bab54',
  slice3: '#326475',
  slice4: '#42c5cb',
  slice5: '#3f92a9',
  slice6: '#224d5d',
  slice7: '#596d7e',
  slice8: '#028173',
  slice9: '#337287',
};
